import { getLocaleTime } from '../../utils.js'
const fb = require('../../firebaseConfig.js')

export default {
    state: {
        worker: {},
		workerId: '',
		workers: [],
		workersPagination: { page: 1, pageSize: 10, lastVisible: null, showLoadMore: true }
    },
    getters: {
        worker: (state) => {
			return state.worker
		},
		workersPagination: (state) => {
			return state.workersPagination
		},
		workers: (state) => {
			return state.workers
		}
    },
    mutations: {
        setWorkers(state, val) {
			state.workers = val
		},
		setWorker(state, val) {
			state.worker = val
		},
		setWorkerId(state, val) {
			state.workerId = val
		},
		setWorkerSalary(state, val) {
			state.worker.contract.salary = val
		},
		setWorkersPagination(state, val) {
			state.workersPagination = val
		}
    },
    actions: {
        updateWorkersPagination({commit}, data) {
            commit('setWorkersPagination', data)
        },
        async fetchWorkers({commit, getters}) {
            let workersPagination = getters.workersPagination
            var query = fb.workersCollection.limit(workersPagination.pageSize)
    
            if (workersPagination.lastVisible != null) {
                query = query.startAfter(workersPagination.lastVisible)
            }
    
            await query.onSnapshot(querySnapshot => {
                if (querySnapshot.empty) {
                    workersPagination.showLoadMore = false
                }
                let workers = (workersPagination.lastVisible != null && workersPagination.pageSize != 1) ? getters.workers : [];
                workersPagination.lastVisible = querySnapshot.docs[querySnapshot.docs.length-1];
    
                querySnapshot.forEach((worker) => {
                    let workerEdited = worker.data()
                    workerEdited.birthDate = getLocaleTime(workerEdited.birthDate.toDate())
                    workerEdited.contract.startDate =  getLocaleTime(workerEdited.contract.startDate.toDate())
                    workerEdited.contract.endDate = getLocaleTime(workerEdited.contract.endDate.toDate())
                    workerEdited.showDetails = false
                    workerEdited.id = worker.id
                    workers.push(workerEdited)
                })
    
                if (workersPagination.page * workersPagination.pageSize > workers.length) {
                    workersPagination.showLoadMore = false
                }
                commit('setWorkersPagination', workersPagination)
                commit('setWorkers', workers)
            })
        },
        async fetchWorker({commit}, { workerId }) {
            await fb.workersCollection.doc(workerId).get().then(res => {
                let currentWorker = res.data()
                currentWorker.id = workerId
                currentWorker.contract.startDate = getLocaleTime(res.data().contract.startDate.toDate())
                currentWorker.contract.endDate = getLocaleTime(res.data().contract.endDate.toDate())
                currentWorker.birthDate = getLocaleTime(res.data().birthDate.toDate())
                commit('setWorker',currentWorker)
            })
        },
        createWorker({commit,state}, payload) {
            if(payload.id) {
                fb.workersCollection.doc(payload.id).update({
                    idNumber: payload.idNumber,
                    firstName: payload.firstName,
                    lastName: payload.lastName,
                    birthDate: fb.fromDate(payload.birthDate),
                    phoneNumber: payload.phoneNumber,
                    email: payload.email,
                    isActive: payload.isActive,
                    contract: {
                        type: payload.contract.type,
                        startDate: fb.fromDate(payload.contract.startDate),
                        endDate: fb.fromDate(payload.contract.endDate),
                        salary: payload.contract.salary,
                        position: payload.contract.position,
                        costCenter: payload.contract.costCenter
                    }
                })
                return
            }
            fb.workersCollection.add({
                idNumber: state.worker.idNumber,
                firstName: state.worker.firstName,
                lastName: state.worker.lastName,
                birthDate: fb.fromDate(payload.birthDate),
                phoneNumber: state.worker.phoneNumber,
                email: state.worker.email,
                isActive: state.worker.isActive,
                contract: {
                    type: state.worker.contract.type,
                    startDate: fb.fromDate(state.worker.contract.startDate),
                    endDate: fb.fromDate(state.worker.contract.endDate),
                    salary: state.worker.contract.salary,
                    position: state.worker.contract.position,
                    costCenter: payload.contract.costCenter
                }
            }).then(ref => {
                let currentWorker = state.worker
                currentWorker.id = ref.id
                commit('setWorker', currentWorker)
            })
        }
    }
}